module.exports = __webpack_public_path__ + "static/media/sponsorBayFloor1.2fb71314.jpg";